import { Controller } from "@hotwired/stimulus"

// Task Drawer — DEPRECATED: now delegates to the universal slide-panel controller.
// Kept for backwards compatibility with any code dispatching task-drawer:open events.
// All new code should use data-action="click->slide-panel#open" instead.

export default class extends Controller {
  static targets = ["container", "backdrop", "panel", "title", "body", "fullLink"]

  connect() {
    // Legacy: re-dispatch as slide-panel:open
    document.addEventListener("task-drawer:open", this.handleOpen.bind(this))
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("task-drawer:open", this.handleOpen.bind(this))
    document.removeEventListener("keydown", this.boundKeydown)
  }

  handleOpen(event) {
    // Delegate to slide-panel
    const { url, title } = event.detail
    document.dispatchEvent(new CustomEvent("slide-panel:open", {
      detail: { url, title }
    }))
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const url = event.currentTarget.dataset.taskUrl || event.currentTarget.href
    const title = event.currentTarget.dataset.taskTitle || "Task"
    document.dispatchEvent(new CustomEvent("slide-panel:open", {
      detail: { url, title }
    }))
  }

  close() { /* no-op — slide-panel handles it */ }
  onKeydown() { /* no-op — slide-panel handles it */ }
}
